<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app{
  min-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue